import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentModalActiveSurvey = styled.div`
  left: 61.2%;
  top: 50px;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  width: 50%;
  max-width: 381px;
  height: fit-content;
  max-height: 480px;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 900px) {
    left: 33.2%;
    top: 38px;
  }
  @media only screen and (min-width: 901px) and (max-width: 1019px) {
    left: 45.2%;
    top: 45px;
  }
  @media only screen and (min-width: 1020px) and (max-width: 1300px) {
    left: 52.2%;
    top: 42px;
  }
  @media only screen and (min-width: 1301px) and (max-width: 1600px) {
    left: 60.2%;
  }
  @media only screen and (min-width: 1601px) and (max-width: 1900px) {
    left: 68.2%;
  }
  @media only screen and (min-width: 1901px) and (max-width: 2700px) {
    left: 73.2%;
  }
`;

export const CloseModalActiveSurvey = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalActiveSurvey = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  height: 8em;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ButtonActiveSurvey = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    background-color: rgba(46, 46, 46, 1);
  }
`;
export const ButtonActiveSurveyCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: white;
  border-radius: 4px;
  border: 1px solid;
  margin: 1em auto;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .content-sos-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 13vw;
    height: 12vw;
    @media only screen and (min-width: 2000px) and (max-width: 3000px) {
      height: 8vw;
    }
  }
  .sos-button {
    width: 10vw;
    height: 10vw;
    border-radius: 50%;
    max-width: 180px;
    max-height: 180px;
    background: radial-gradient(
      50% 50% at 50% 50%,
      #f7953b 11.05%,
      #f7953b 43.87%,
      #f7953b 67.3%,
      #e4842c 96.99%,
      #f7953b 100%
    );
    box-shadow: 0px 0px 12px rgb(0 0 0 / 30%);
    outline: none;
    border: none;
    color: ${({ theme }) => theme.neutral.white};
    font-weight: 900;
    font-size: 42px;
    &:hover {
      width: 13vw;
      height: 13vw;
    }
  }
  p {
    width: 92%;
    margin-top: 20px;
    font-size: 18px;
    text-align: center;
    @media only screen and (max-width: 2000px) {
      margin-top: 15px;
    }
  }
`;

export const SOSButton = styled.button`
  width: 13vw;
  height: 13vw;
  border-radius: 50%;
  max-width: 120px;
  max-height: 120px;
  background: radial-gradient(
    53.21% 53.21% at 50% 50%,
    ${({ theme }) => theme.primary.purple} 54.17%,
    ${({ theme }) => theme.primary.purple} 100%
  );
  opacity: ${({ buttonStatus }) => (buttonStatus !== "Open" ? 1 : 0.4)};
  box-shadow: 0px 0px 12px rgb(0 0 0 / 30%);
  outline: none;
  border: none;
  color: ${({ theme }) => theme.neutral.white};
  font-weight: 900;
  font-size: 30px;
  transition: 0.2s all;
  @media only screen and (max-width: 750px) {
    font-size: 20px;
  }
  cursor: ${({ buttonStatus }) =>
    buttonStatus !== "Open" ? "pointer !important" : "no-drop !important"};
  &:hover {
    transform: ${({ buttonStatus }) =>
      buttonStatus !== "Open" ? "scale(0.98)" : ""};
    box-shadow: ${({ buttonStatus }) =>
      buttonStatus !== "Open" ? " 3px 2px 22px 1px rgb(0 0 0 / 24%)" : ""};
  }
  .push-here {
    font-size: 14px;
    font-weight: 900;
    width: 100%;
    margin: 0;
    @media only screen and (max-width: 750px) {
      font-size: 10px;
    }
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  color: grey;
`;
